"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgBeachSand = function SvgBeachSand(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 34",
    role: "img"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.23 28.541s-1.084.418-2.295-1.843c-1.212-2.262-4.068-3.02-4.068-3.02s-3.27-.655-2.729-4.52c.126-.767.735-.85.735-.85s-1.393-1.244-.58-2.687c.811-1.442 1.355-2.597 2.848-2.597.48-1.345.817-1.443 1.429-1.758.612-.316 2.3-.677 2.3-.677s1.319-.38 2.188.758"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.962 28.541s1.085.418 2.296-1.843c1.211-2.262 4.067-3.02 4.067-3.02s3.271-.655 2.73-4.52c-.126-.767-.735-.85-.735-.85s1.393-1.244.58-2.687c-.812-1.442-1.355-2.597-2.848-2.597-.48-1.345-.817-1.443-1.43-1.758-.61-.316-2.299-.677-2.299-.677s-1.319-.38-2.188.758m-8.097 7.106 4.085 3.858m-1.821-9.519 3.665 8.238m2.278-9.37v9.62m6.422-8.488-3.309 8.123m5.252-2.462-4.12 4.253m-7.544 2.539s-1.512 1.487-1.512 2.357c0 .87 1.527.714 1.527.714s1.774-.078 2.339-.078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.448 25.245s1.512 1.487 1.512 2.357c0 .87-1.527.714-1.527.714s-1.774-.078-2.339-.078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1 14.44C34.069 9.974 32.106 6 29.861 6c-2.567 0-4.666 5.703-4.666 5.703L22 17.763m6 4.012S24.829 18 21.436 18c-3.393 0-2.936 3.775-5.602 5.46-2.666 1.685-4.455 0-5.834 4.617",
    stroke: "#17181A"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0,
    fill: "#17181A",
    transform: "translate(10 6)"
  }, /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 39.132 0)",
    cx: 19.566,
    cy: 7.566,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 25.132 0)",
    cx: 12.566,
    cy: 16.566,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 51.132 0)",
    cx: 25.566,
    cy: 19.566,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 37.132 0)",
    cx: 18.566,
    cy: 21.566,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    transform: "matrix(-1 0 0 1 47.132 0)",
    cx: 23.566,
    cy: 11.566,
    r: 1
  }))));
};

var Memo = /*#__PURE__*/(0, React.memo)(SvgBeachSand);
var _default = Memo;
exports["default"] = _default;